<template>
  <ConfirmModal
      color="info"
      icon="mdi-check"
      :maxWidth="500"
      itemKey="Ticket"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setQuestion="setQuestion"
      :confirmData="protocolConfirmData"
      @onConfirm="(response) => $emit('onProtocolConfirm', response)"
      v-bind="$attrs"
  />
</template>

<script>
  import Tickets from '@/services/tickets'

  import ConfirmModal from '@/components/_Part/_Modal/Confirm'

  export default {
    name: 'ProtocolConfirm',
    props: [
      'id'
    ],
    emits: [
      'onProtocolConfirm'
    ],
    components: {
      ConfirmModal
    },
    methods: {
      fetchData() {
        return Tickets
          .read({
            id: this.id
          })
      },
      setTitle(Item) {
        return 'Potvrdiť protokol č.' + Item.id
      },
      setQuestion(Item) {
        return 'Naozaj chcete potvrdiť protokol č.' + Item.id + '?'
      },
      protocolConfirmData() {
        return Tickets
          .protocolConfirm({
            id: this.id
          })
      }
    }
  }
</script>
